import { type Ref, forwardRef } from "react";
import type { SVGProps } from "react";
const LogOutIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    width={24}
    height={24}
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M10.502 3.002a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-4.5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h4.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-4.5a3 3 0 0 1-3-3v-12a3 3 0 0 1 3-3zm10.35 9.354a.5.5 0 0 0 0-.707l-4-4a.5.5 0 0 0-.708 0l-.707.707a.5.5 0 0 0 0 .707l1.94 1.94H8.29a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9.085l-1.939 1.938a.5.5 0 0 0 0 .708l.707.707a.5.5 0 0 0 .707 0z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(LogOutIcon);
export default ForwardRef;
